import type { DateTimeFilter, GTimePickerProps } from '~/presentation/ui';

import { useDateTimeFilter } from '../hooks/useDateTimeFilter';
import { useDateTimePicker } from '~/presentation/ui';
import { BaseTimePicker } from './BaseTimePicker';
import { getDateRangeTitle } from '../helpers';

export type MainTimePickerProps = Omit<GTimePickerProps, 'isCompare'>;
export const MainTimePicker: React.FC<MainTimePickerProps> = (props) => {
  const { rangeAddition, popoverProps, activator, onApply, activatorProps, actionProps } = props;

  const { DATE_TIME_FILTERS } = useDateTimeFilter();

  const dateTimeFilters = DATE_TIME_FILTERS;
  const additionalRanges = rangeAddition?.rangers || [];
  const initialPicked = rangeAddition?.initialPicked;
  const ranges: DateTimeFilter[] = [...dateTimeFilters, ...additionalRanges];

  const { dateTimePicked } = useDateTimePicker({ ranges, initialPicked });

  const getButtonValue = () => {
    if (dateTimePicked.isVersion && additionalRanges.length > 0) {
      const time = dateTimePicked.description ? `at ${dateTimePicked.description}` : '';
      return `Period: ${dateTimePicked.title} ${time}`;
    }

    if (dateTimePicked.alias === 'custom') {
      return getDateRangeTitle(dateTimePicked.since, dateTimePicked.until);
    }

    return dateTimePicked.title;
  };

  return (
    <BaseTimePicker
      activatorProps={activatorProps}
      dateTimeFilters={dateTimeFilters}
      rangeAddition={rangeAddition}
      popoverProps={popoverProps}
      actionProps={actionProps}
      buttonValue={getButtonValue()}
      activator={activator}
      onApply={onApply}
    />
  );
};
